import { FilteringList, ListItem, RadioButtonWithLabelGroupWidget, RadioLayoutType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { IExtractTaskSchedule } from '~src/extractTask/actions/CreateExtractTaskAction';
import { ExtractTaskType } from '~src/extractTask/serverApi/types/IExtractTask';
import { matchesSearch, toListItem } from '~src/schedule/components/SchedulePickerActionBody';
import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';

export function localizeExtractTaskType(type: string): string {
    switch (type) {
        case ExtractTaskType.ExtractServiceIncrement:
        case ExtractTaskType.IncrementExtract:
            return Messages.incrementalRefresh();
        case ExtractTaskType.ExtractServiceFullRefresh:
        case ExtractTaskType.RefreshExtract:
            return Messages.fullRefresh();
    }
}

export interface TabbedScheduleDialogTabBodyProps {
    prompt: string;
    allowIncremental: boolean;
    scheduleOptions: IScheduleInfo[];
    setExtractSchedule: (schedule: IExtractTaskSchedule) => void;
}

export function TabbedScheduleDialogTabBody(props: TabbedScheduleDialogTabBodyProps) {
    const [searchText, setSearchText] = React.useState('');
    const [selectedSchedule, setSelectedSchedule] = React.useState(undefined as IScheduleInfo);
    const [extractTypeSelectedIndex, setExtractTypeSelectedIndex] = React.useState(0);
    const extractTaskTypes = Object.values(ExtractTaskType);

    const onSelectSchedule = (id: string) => {
        const schedule = props.scheduleOptions.find((schedule) => schedule.id === id);
        if (schedule) {
            setSelectedSchedule(schedule);
            setSearchText(schedule.name);
            props.setExtractSchedule({ schedule: schedule, type: extractTaskTypes[extractTypeSelectedIndex] });
        }
    };
    const getRefreshTypeOptions = () => {
        return extractTaskTypes.map((type: string) => ({
            value: type,
            testId: `radio-button-${type}`,
            label: localizeExtractTaskType(type)
        }));
    };

    const listFilterer = (item: ListItem) => matchesSearch(searchText, item);
    const listMapper = (item: IScheduleInfo) => toListItem(false, item);
    const scheduleListItems = props.scheduleOptions.map(listMapper);
    const filteringListStyle: React.CSSProperties = {
        maxHeight: '300px',
        marginTop: '10px',
        border: '1px solid #b2b2b2'
    };

    return <>
        <div>
            <span>{props.prompt}</span>
            <div style={{ marginTop: 6 }}>
                <FilteringList
                    items={scheduleListItems.filter(listFilterer)}
                    searchPlaceholder={Messages.search()}
                    testId={'filtering-list-schedule'}
                    onFilterChange={(value: string) => setSearchText(value)}
                    searchText={searchText}
                    onSelect={onSelectSchedule}
                    style={filteringListStyle}
                />
            </div>
            {props.allowIncremental && <>
                <div style={{ marginTop: 24 }}>
                    <RadioButtonWithLabelGroupWidget
                        label={Messages.extractTasksTypePrompt()}
                        ariaLabel='The type of extract to schedule'
                        buttonList={getRefreshTypeOptions()}
                        checkedIndex={extractTypeSelectedIndex}
                        handleChange={(_: string, checkedIndex: number) => {
                            setExtractTypeSelectedIndex(checkedIndex);
                            props.setExtractSchedule({ schedule: selectedSchedule, type: extractTaskTypes[checkedIndex] });
                        }}
                        layout={RadioLayoutType.Veritical}
                    />
                </div>
            </>}
        </div>
    </>;
}
